module.exports = __webpack_public_path__ + "img/aktivrute-480.f551b186.png";